import React from 'react';
import { Row, Col } from 'react-bootstrap';

const ProductSelector = ({ products, selectedProduct, onProductChange }) => {
  const getCapacityColor = (puissance) => {
    if (puissance >= 15000) return '#FF6B6B';
    if (puissance >= 6000) return '#4ECDC4';
    return '#56AB2F';
  };

  return (
    <Row className="my-5">
      <Col lg={8} className="mx-auto">
        <div className="product-selector-card p-4 shadow-lg rounded-3">
          <div className="text-center mb-4">
            <h3 className="fw-bold text-primary mb-2">
              <span className="selector-icon">☀️</span> Choisissez Votre Pack Solaire
            </h3>
            <p className="text-muted">Sélectionnez la capacité qui correspond à vos besoins énergétiques</p>
          </div>
          
          <div className="selector-container position-relative">
            <div 
              className="selector-highlight"
              style={{
                background: 'linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)',
                borderRadius: '12px',
                position: 'absolute',
                top: `${(selectedProduct.id / products.length) * 100}%`,
                height: `${100 / products.length}%`,
                width: '100%',
                transition: 'top 0.3s ease, height 0.3s ease',
                zIndex: 1
              }}
            />
            
            <div className="position-relative z-2">
              {products.map(product => (
                <div
                  key={product.id}
                  className={`product-option p-3 d-flex align-items-center justify-content-between ${
                    selectedProduct.id === product.id ? 'active' : ''
                  }`}
                  onClick={() => onProductChange(product)}
                  style={{
                    cursor: 'pointer',
                    borderBottom: '1px solid #f0f0f0',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div 
                      className="capacity-indicator me-3"
                      style={{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: getCapacityColor(product.puissance),
                        boxShadow: `0 0 0 ${selectedProduct.id === product.id ? '4px' : '0px'} rgba(${
                          parseInt(getCapacityColor(product.puissance).slice(1, 3), 16)
                        }, ${
                          parseInt(getCapacityColor(product.puissance).slice(3, 5), 16)
                        }, ${
                          parseInt(getCapacityColor(product.puissant).slice(5, 7), 16)
                        }, 0.2)`
                      }}
                    />
                    <div>
                      <div className="fw-bold">{product.name}</div>
                      <div className="text-muted small">
                        {product.puissance.toLocaleString()} Wh -{' '}
                        {product.puissance >= 15000 ? 'Grande capacité' : 
                         product.puissance >= 6000 ? 'Moyenne capacité' : 'Petite capacité'}
                      </div>
                    </div>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <div className="price-tag me-3">
                      <span className="fw-bold text-primary">
                        {Math.round(product.puissance / 1000)}kWh
                      </span>
                    </div>
                    <div className={`selection-indicator ${selectedProduct.id === product.id ? 'active' : ''}`}>
                      <div className="indicator-circle"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="text-center mt-4 pt-3 border-top">
            <div className="selected-product-info">
              <h5 className="fw-bold mb-2">Pack Sélectionné</h5>
              <div className="d-flex justify-content-center align-items-center">
                <div 
                  className="selected-capacity-indicator me-3"
                  style={{
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    backgroundColor: getCapacityColor(selectedProduct.puissance)
                  }}
                />
                <span className="fw-bold text-dark">{selectedProduct.name}</span>
                <span className="ms-2 badge bg-primary">
                  {selectedProduct.puissance.toLocaleString()} Wh
                </span>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ProductSelector;